export default "__VITE_ASSET__95dd7b53__"